import { render, staticRenderFns } from "./DChangeAttributeConfirmation.vue?vue&type=template&id=7092f279&scoped=true&"
import script from "./DChangeAttributeConfirmation.vue?vue&type=script&lang=js&"
export * from "./DChangeAttributeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DChangeAttributeConfirmation.vue?vue&type=style&index=0&id=7092f279&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7092f279",
  null
  
)

export default component.exports